import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { SdvorButtonComponent } from '@sdvor/shared/ui';
import { SdvorSubmitOrderComponent } from './submit-order.component';

@NgModule({
  declarations: [SdvorSubmitOrderComponent],
  imports: [AsyncPipe, SdvorButtonComponent],
  exports: [SdvorSubmitOrderComponent],
})
export class SdvorSubmitOrderModule {}
